import { createContext } from "react";
const defaultStyles = {
    topLevelBoxStyle: {},
    contentFlexStyle: {},
    inputStyle: {},
    recordingIndicatorStyle: {}
};
const StyleContext = createContext(defaultStyles);
export { StyleContext };
